// Export the Component Definition for use in Contentful Studio
export {PeopleCollectionContentfulComponentDefinition} from './PeopleCollectionContentfulDefinition';
export {default} from './PeopleCollection';
